import { CART_MODULE } from "@/api_framework/api_config";
import { IGeoAddressState, IGeoSearchResponse } from "@/api_framework/api_modals/GeoAddresses";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useAddressSearchAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const [geoAddress, setGeoAddress] = useState<IGeoAddressState[]>([]);
  const clearGeoSearch = () => {
    setGeoAddress([]);
  };
  const execute = useCallback(async (query: string) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      dispatch(
        setLoading({
          key: "isGeoLocationSearchInProgress",
          status: true,
        }),
      );
      await axios
        .get(CART_MODULE?.ADDRESS_SEARCH?.baseURL ?? "", {
          params: {
            q: query,
          },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IGeoSearchResponse>) => {
          dispatch(
            setLoading({
              key: "isGeoLocationSearchInProgress",
              status: false,
            }),
          );
          if (res.data.status === true) {
            const geoAddresses: IGeoAddressState[] = res.data.data.reduce((final, geoAdd) => {
              const splittedAddress = geoAdd.formatted_address.split(",");
              const city: string = splittedAddress[splittedAddress.length - 3].replace(/\d+/g, "").trim();
              const state: string = splittedAddress[splittedAddress.length - 2].replace(/\d+/g, "").trim();
              let pincode: string = "";
              const p: string[] = splittedAddress[splittedAddress.length - 2].match(/\d+/g) ?? [];
              if (p?.length > 0) {
                pincode = p[0]?.trim();
              }

              final.push({
                formattedAddress: geoAdd.formatted_address,
                city: city.split(" ")[0],
                state,
                placeId: geoAdd.place_id,
                pincode,
                lat: geoAdd.geometry.location.lat,
                long: geoAdd.geometry.location.lng,
              });
              return final;
            }, [] as IGeoAddressState[]);
            setGeoAddress(geoAddresses);
          } else {
            setGeoAddress([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          dispatch(
            setLoading({
              key: "isGeoLocationSearchInProgress",
              status: false,
            }),
          );
          if (e.code === "ERR_BAD_REQUEST") {
            setGeoAddress([]);
          }
        });
    } catch (e: any) {
      toast.error("Open Street API Failed: " + e.message);
    }
  }, []);
  return { geoAddress, execute, clearGeoSearch };
};
